// extracted by mini-css-extract-plugin
export default {"light":"DbiLogo_light__BuPY2","dark":"DbiLogo_dark__SaR-4"};